module.exports = __webpack_public_path__ + "static/media/confetti.070bf937.png";